import React, { useEffect, useRef, useState } from 'react';
import { Send, Pin, Megaphone } from 'lucide-react';

export const fmtTime = (iso) => { try { return new Date(iso).toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' }); } catch { return ''; } };

// Scrolling chat list; `actions(m)` renders moderator buttons per message.
export const ChatList = ({ messages, pinned, actions, testid = 'chat-list' }) => {
  const end = useRef(null);
  useEffect(() => { end.current?.scrollIntoView({ block: 'end' }); }, [messages.length]);
  return (
    <div className="flex min-h-0 flex-1 flex-col">
      {pinned && <div className="mb-2 flex gap-2 rounded-xl bg-amber-50 px-3 py-2 text-xs ring-1 ring-amber-200" data-testid="chat-pinned"><Pin className="mt-0.5 h-3.5 w-3.5 shrink-0 text-amber-600" /><span><b>{pinned.name}:</b> {pinned.text}</span></div>}
      <div className="min-h-0 flex-1 space-y-2 overflow-y-auto pr-1" data-testid={testid}>
        {messages.length === 0 && <p className="py-6 text-center text-xs text-slate-400">No messages yet</p>}
        {messages.map((m) => (
          <div key={m.id} className={`group rounded-xl px-3 py-2 text-sm ${m.kind === 'announcement' ? 'bg-indigo-50 ring-1 ring-indigo-200' : m.status === 'pending' ? 'bg-slate-50 ring-1 ring-dashed ring-slate-300' : m.status === 'deleted' ? 'opacity-40 line-through' : 'bg-slate-50'}`} data-testid={`chat-msg-${m.id}`}>
            <div className="flex items-center gap-1.5 text-[11px] text-slate-500">
              {m.kind === 'announcement' && <Megaphone className="h-3 w-3 text-indigo-600" />}
              <b className={m.is_staff ? 'text-indigo-700' : 'text-slate-800'}>{m.name}</b>{m.is_staff && <span className="rounded bg-indigo-600 px-1 text-[9px] font-bold text-white">HOST</span>}
              <span>{fmtTime(m.at)}</span>{m.status === 'pending' && <span className="font-bold text-amber-600">Awaiting approval</span>}
            </div>
            <p className="mt-0.5 break-words text-slate-800">{m.text}</p>
            {actions && <div className="mt-1 flex flex-wrap gap-1">{actions(m)}</div>}
          </div>
        ))}
        <div ref={end} />
      </div>
    </div>
  );
};

export const ChatInput = ({ onSend, placeholder = 'Say something…', disabled, testid = 'chat-input' }) => {
  const [t, setT] = useState('');
  const submit = async (e) => { e.preventDefault(); const v = t.trim(); if (!v) return; setT(''); await onSend(v); };
  return (
    <form onSubmit={submit} className="mt-2 flex gap-2">
      <input value={t} onChange={(e) => setT(e.target.value)} maxLength={500} disabled={disabled} placeholder={placeholder} data-testid={testid}
        className="min-w-0 flex-1 rounded-xl border border-slate-200 bg-white px-3 py-2 text-sm outline-none focus:border-indigo-400 disabled:bg-slate-100" />
      <button type="submit" disabled={disabled || !t.trim()} data-testid={`${testid}-send`} className="grid h-9 w-9 shrink-0 place-items-center rounded-xl bg-[#15133A] text-white disabled:opacity-40"><Send className="h-4 w-4" /></button>
    </form>
  );
};
